module.exports = __webpack_public_path__ + "img/head_ysb@2x.1a066e2a.png";